import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import { browserHistory } from 'react-router';
import useMutation from '../../modules/react/hooks/useMutation';
import BlogPostForm from '../components/BlogPostForm';
import { GET_BLOG_DATA_QUERY } from '../../src/admin/modules/blog/containers/List';

const CREATE_BLOG_POST = gql`
  mutation CreateBlogPost($post: BlogPostCreateInput!) {
    blogPostCreate(post: $post) {
      post {
        id
      }
    }
  }
`;

const successMessage = 'Blog post created successfully';

const BlogPostCreateContainer = () => {
  const [createBlogPost, { data, loading }] = useMutation(CREATE_BLOG_POST,
    { refetchQueries: [GET_BLOG_DATA_QUERY] });

  useEffect(() => {
    if (!loading && data?.blogPostCreate?.post?.id) {
      browserHistory.push(`/admin/blog/edit/${data.blogPostCreate.post.id}`);
    }
  }, [data, loading]);

  const onSubmit = post => createBlogPost({ variables: { post } });

  const errors = data?.blogPostCreate?.userErrors?.length
    ? data.blogPostCreate.userErrors
    : undefined;

  return (
    <BlogPostForm
      errors={errors}
      isSubmitting={loading}
      onSubmit={onSubmit}
      successMessage={successMessage}
    />
  );
};

export default BlogPostCreateContainer;
